import { render, staticRenderFns } from "./AsistenciaValidaciones.vue?vue&type=template&id=482be253&"
import script from "./AsistenciaValidaciones.vue?vue&type=script&lang=js&"
export * from "./AsistenciaValidaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports